import styled from 'styled-components'

import { TEPopup } from '../TEPopup'

export const Popup = styled(TEPopup)`
	.TEPopupContent {
		width: 90%;
		max-width: 900px;
		margin: 100px auto;
		padding: 30px;
	}
`
